import type { QueryParamsDto } from "@mimber/schema"

/**
 * Query key utilities for account hooks
 * Key names match AccountController / MfaController method names
 */
export const accountKeys = {
  getStatus: () => ["account", "mfa", "getStatus"] as const,
  getRemainingRecoveryCodes: () =>
    ["account", "mfa", "getRemainingRecoveryCodes"] as const,
  getStepUpStatus: () => ["account", "mfa", "getStepUpStatus"] as const,
} as const

/**
 * Query key utilities for security events hooks
 * Key names match SecurityEventsController method names
 */
export const securityEventsKeys = {
  findAll: (params?: QueryParamsDto) =>
    params
      ? (["security-events", "findAll", params] as const)
      : (["security-events", "findAll"] as const),
} as const

/**
 * Query key utilities for social linking hooks
 * Key names match SocialLinkingController method names
 */
export const socialLinkingKeys = {
  getLinkedProviders: () =>
    ["account", "social", "getLinkedProviders"] as const,
} as const

/**
 * Query key utilities for notification preference hooks
 * Key names match NotificationPreferencesController method names
 */
export const notificationPreferencesKeys = {
  getPreferences: () =>
    ["account", "notification-preferences", "getPreferences"] as const,
} as const
